import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { IDatePickerConfig } from 'ng2-date-picker';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { ConfirmComponent } from 'src/app/shared/modal/confirm/confirm.component';
import { Bndes } from 'src/app/shared/models/bndes.model';
import { BndesFilter } from 'src/app/shared/models/bndesFilter.model';
import { BndesService } from 'src/app/shared/services/core/bndes.service';

@Component({
  selector: 'app-programa-bndes',
  imports: [TegelModule, CommonModule],
  templateUrl: './programa-bndes.component.html',
  styleUrl: './programa-bndes.component.scss'
})
export class ProgramaBndesComponent implements OnInit {
  bndes: Bndes[];
  bndesFilter: BndesFilter;
  page = 1;
  total!: number;
  reverse: boolean = false;
  order = "ID";

  dateConfigPeriodFrom: IDatePickerConfig ={
    //locale: 'pt',
    format: 'DD/MM/YYYY',
    showMultipleYearsNavigation: true,
    disableKeypress: true
  };

  dateConfigUpTo: IDatePickerConfig = {
    //locale: 'pt',
    format: 'DD/MM/YYYY',
    showMultipleYearsNavigation: true,
    disableKeypress: true
  };

  constructor(
    private bndesService: BndesService,
    private dialogService: DialogService,
    private toastr: ToastrService,
    private utilService: UtilService
  ) {
    this.bndesFilter = new BndesFilter();
    this.bndes = [];
  }

  ngOnInit(): void { }

  changeDateFrom(value: any) {
    this.dateConfigUpTo.min = value;
    this.dateConfigUpTo = { ...this.dateConfigUpTo };
  }

  changeDateTo(value: any){
    this.dateConfigPeriodFrom.max = value;
    this.dateConfigPeriodFrom = { ...this.dateConfigPeriodFrom };
  }

  deleteBndes(bndes: Bndes){
    this.dialogService.addDialog(ConfirmComponent, {
      title: 'Confirmar',
      message: 'Deseja excluir o programa ' + bndes.title + ' ?'
    }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
      if (resultConfirm.confirmed) {
        this.bndesService.delete(bndes.id).subscribe((result) => {
          if (result && !result.hasErrors) {
            let index = 0;
            do {
              index = this.bndes.findIndex(c => c.id === bndes.id);
              if(index > -1) {
                this.bndes.splice(index, 1);
              }
            } while (index != -1);

            this.toastr.success('Registro excluído.', 'Sucesso');
            }
        });
      }
    });
  }

  // openSaveBndes(bndes = new Bndes()) {
  //   this.dialogService.addDialog(SaveBndesComponent, {
  //     bndes: bndes
  //   }, this.utilService.getModalOptions()).subscribe((result) => {
  //       if(result && result.success){
  //         this.getAllBndes(this.page);
  //         this.toastr.success('Registro salvo.', 'Sucesso');
  //       }
  //   });
  // }

  getAllBndes(page: number){
    this.bndesService.get(page, this.order, this.utilService.getOrderType(this.reverse), this.bndesFilter).subscribe((result) => {
      this.bndes = result.page;
      this.page = result.currentPage;
      this.total = result.totalRecords;
    });
  }

  resetFilters(form: NgForm) {
    this.bndesFilter = new BndesFilter();
    form.resetForm(this.bndesFilter);

    this.changeDateFrom(null);
    this.changeDateTo(null);
  }

  search() {
    this.getAllBndes(1);
  }

}
